export default __webpack_public_path__ + "static/clock-af64dfedf24aaa2b528b270483abc65c.jpg";